import { Pipe, PipeTransform } from '@angular/core';

/**
 * Hilight text in the autocomplete item and add sub name when needed.
 */
@Pipe({
  name: 'autocompleteItemName',
  standalone: false,
})
export class AutoCompleteItemNamePipe implements PipeTransform {
  transform(value: string, subName: string, keyword: string, highlightName: boolean): string {
    if (!value) {
      return '';
    }

    let name: string = '<span class="name">' + this.highlightSearchText(highlightName, value, keyword) + '</span>';

    if (!subName) {
      return name;
    }

    return (name += ' <span class="sub-name">' + this.highlightSearchText(highlightName, subName, keyword) + '</span>');
  }

  // Highlights part of the text if it matches the search keywords. This gives the user a visual aid as to why the search results are being displayed.
  private highlightSearchText(highlightSearchTerm: boolean, originalText: string, searchKeywords: string): string {
    if (!highlightSearchTerm) {
      return originalText;
    }

    let name: string = originalText;
    // Find matches first to preserve orignial letter casing,
    // otherwise if you do a simple keyword replace then when searching for 'john'
    // you would have John replaced with john.
    if (searchKeywords) {
      searchKeywords = this.escapeRegExp(searchKeywords); // Escape special regex characters otherwise regexp throws an error.
    }
    const re = new RegExp(searchKeywords, 'i'); // ignore case
    const found = originalText.match(re);

    if (found && found.length > 0) {
      name = originalText.replace(found[0], '<span class="hilite">' + found[0] + '</span>');
    }

    return name;
  }

  private escapeRegExp(str) {
    // eslint-disable-next-line no-useless-escape
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
  }
}
